import { useState } from "react";
import { InfoIcon, SeatIcon, ViewBoxIcon } from "../../../../components/GlobalIcons";
import "./style.css";
import { convertTicketFormat, ctgUnderscoreRemoverfucntion, getDayFromDate } from "../../../../utils/func";
import DropBoxPop from "./DropBoxPop";
import { useContext } from "react";
import { filterDataContext } from "../../../../App";
import CustomModal from "../../../../components/CustomModal";
import TicketLoader from "../../../../components/Loaders/TicketLoader";
import TicketContent from "../TicketContent";
// import CustomModal from "../../../../components/CustomModal";

const EventTicketDetail = ({
  ticketData,
  ticketCategories,
  handlerSetWhislist,
  tickerLoader,
  setOnHoverCatIdFromEvent,
  onHoverCatIdFromEvent,
  onHoverCatIDFromSvg,
  reserveTicket,
  showNotifyPopUp, setShowNotifyPopUp
}) => {
  const [PopupShow, SetPopupShow] = useState(false);
  const [ticketPopUpIndex, setTicketPopUpIndex] = useState();
  const [priceTicketCategoryIndex, setPriceTicketCategoryIndex] = useState();
  const [pricePopuUpIndex, setPricePopUpIndex] = useState();
  const [numberedSeatIndex, setNumberedSeatIndex] = useState();
  const [coveredSeatIndex, setCoveredSeatIndex] = useState();
  const [videoWallIndex, setVideoWallIndex] = useState();
  const [standingIndex, setStandingIndex] = useState();
  const { reservationData, whislistItem } = useContext(filterDataContext)


  const daysGrouped = (items) => {
    const daysObject = {};
    items.forEach((item) => {
      const { eventdays, ticket_validfrom } = item;
      const day =
        eventdays === "singleday"
          ? getDayFromDate(ticket_validfrom)
          : convertTicketFormat(eventdays);
      if (daysObject[day]) {
        daysObject[day].push(item);
      } else {
        daysObject[day] = [item];
      }
    });
    return daysObject;
  };


  const getTicketCategorieInfo = (name) => {
    let data = ticketCategories?.filter((item) => {
      return item.category_name === name;
    });
    if (data) {
      return data?.[0];
    }
  };

  const handleShowPopuUp = (func, index) => {
    func(index);
  };


  const closePopUp = (func) => {
    func();
  };


  const checkCategoriesIcon = (category_name) => {
    let data = ticketCategories?.filter((item) => {
      return item.category_name === category_name;
    });
    if (data?.length > 0) {
      let ans = JSON.parse(data[0]?.options);
      return ans;
    }
  };

  const convertTicketDeliveryDate = (date) => {
    if (date <= 1) {
      return "24 hours ";
    } else if (date % 7 !== 0) {
      return `${date} days `;
    } else if (date % 7 === 0) {
      return `${date / 7} weeks `;
    } else {
      return `${date} days `;
    }
  };


  const getHoverOnBasedOfTicket = (eventName, data, svgData) => {
    const ticketsOnBasedOfEvents = data?.[eventName]?.map((item) =>
      ctgUnderscoreRemoverfucntion(item.category_id)
    );
    if (ticketsOnBasedOfEvents && svgData?.some((cls) =>
      ticketsOnBasedOfEvents.includes(ctgUnderscoreRemoverfucntion(cls))
    )) {
      return true;
    }
    return false;
  }

  return (
    <>
      {tickerLoader ? (
        <>
          <TicketLoader />
          <TicketLoader />
          <TicketLoader />
        </>
      ) : (
        <>
          {Object.entries(ticketData)?.map((event, ticektindex) => {
            return (
              <div className="eventTicketDetail_section" key={ticektindex}>
                <div className="ticketDetail_header">
                  <h6>{event[0]}</h6>
                  <div>
                    {checkCategoriesIcon(event[0])?.numbered_seat === true && (
                      <span
                        className="icon_for_drop_info"
                        onMouseEnter={() => {
                          handleShowPopuUp(setNumberedSeatIndex, ticektindex);
                        }}
                        onMouseLeave={() => closePopUp(setNumberedSeatIndex)}
                      >
                        <SeatIcon />
                        <div
                          className={`drop_box_ticket ${numberedSeatIndex === ticektindex ? "active" : ""
                            }`}
                        >
                          {numberedSeatIndex === ticektindex &&
                            (window.innerWidth < 768 ? (
                              <CustomModal
                                closeFunc={closePopUp}
                                closeFuncState={setNumberedSeatIndex}
                                children={
                                  <DropBoxPop
                                    title={"Numbered seating"}
                                    info={
                                      "This ticket offers you numbered seating"
                                    }
                                    icon={<SeatIcon />}
                                  />
                                }
                              />
                            ) : (
                              <>
                                {
                                  <DropBoxPop
                                    title={"Numbered seating"}
                                    info={
                                      "This ticket offers you numbered seating"
                                    }
                                    icon={<SeatIcon />}
                                  />
                                }
                              </>
                            ))}
                        </div>
                      </span>
                    )}
                    {checkCategoriesIcon(event[0])?.covered_seat === true && (
                      <span
                        className="icon_for_drop_info"
                        onMouseEnter={() => {
                          handleShowPopuUp(setCoveredSeatIndex, ticektindex);
                        }}
                        onMouseLeave={() => closePopUp(setCoveredSeatIndex)}
                      >
                        <ViewBoxIcon />

                        <div
                          className={`drop_box_ticket ${coveredSeatIndex === ticektindex ? "active" : ""
                            }`}
                        >
                          {coveredSeatIndex === ticektindex &&
                            (window.innerWidth < 768 ? (
                              <CustomModal
                                closeFunc={closePopUp}
                                closeFuncState={setCoveredSeatIndex}
                                children={
                                  <DropBoxPop
                                    title={"Covered seating"}
                                    info={"This ticket offers you covered area"}
                                    icon={<ViewBoxIcon />}
                                  />
                                }
                              />
                            ) : (
                              <>
                                {
                                  <DropBoxPop
                                    title={"Covered seating"}
                                    info={"This ticket offers you covered area"}
                                    icon={<ViewBoxIcon />}
                                  />
                                }
                              </>
                            ))}
                        </div>
                      </span>
                    )}
                    {checkCategoriesIcon(event[0])?.videowall === true && (
                      <span
                        className="icon_for_drop_info"
                        onMouseEnter={() => {
                          handleShowPopuUp(setVideoWallIndex, ticektindex);
                        }}
                        onMouseLeave={() => closePopUp(setVideoWallIndex)}
                      >
                        <ViewBoxIcon />

                        <div
                          className={`drop_box_ticket ${videoWallIndex === ticektindex ? "active" : ""
                            }`}
                        >
                          {videoWallIndex === ticektindex &&
                            (window.innerWidth < 768 ? (
                              <CustomModal
                                closeFunc={closePopUp}
                                closeFuncState={setVideoWallIndex}
                                children={
                                  <DropBoxPop
                                    title={"Videowall"}
                                    info={
                                      "This place offers you a large video wall to follow all the action"
                                    }
                                    icon={<ViewBoxIcon />}
                                  />
                                }
                              />
                            ) : (
                              <>
                                {
                                  <DropBoxPop
                                    title={"Videowall"}
                                    info={
                                      "This place offers you a large video wall to follow all the action"
                                    }
                                    icon={<ViewBoxIcon />}
                                  />
                                }
                              </>
                            ))}
                        </div>
                      </span>
                    )}
                    {event[0] === "General Admission" && (
                      <span
                        className="icon_for_drop_info"
                        onMouseEnter={() => {
                          handleShowPopuUp(setStandingIndex, ticektindex);
                        }}
                        onMouseLeave={() => closePopUp(setStandingIndex)}
                      >
                        <ViewBoxIcon />
                        <div
                          className={`drop_box_ticket ${standingIndex === ticektindex ? "active" : ""
                            }`}
                        >
                          {standingIndex === ticektindex &&
                            window.innerWidth < 768 ? (
                            <CustomModal
                              closeFunc={closePopUp}
                              closeFuncState={setStandingIndex}
                              children={
                                <DropBoxPop
                                  title={"Standing"}
                                  info={
                                    " This ticket offers you a standing position"
                                  }
                                  icon={<ViewBoxIcon />}
                                />
                              }
                            />
                          ) : (
                            <>
                              {
                                <DropBoxPop
                                  title={"Standing"}
                                  info={
                                    " This ticket offers you a standing position"
                                  }
                                  icon={<ViewBoxIcon />}
                                />
                              }
                            </>
                          )}
                        </div>
                      </span>
                    )}
                    {event[1][0]?.category_information_available === 1 && (
                      <span
                        className="icon_for_drop_info"
                        onMouseEnter={() => {
                          handleShowPopuUp(setTicketPopUpIndex, ticektindex);
                        }}
                        onMouseLeave={() => closePopUp(setTicketPopUpIndex)}
                      >
                        <InfoIcon />

                        <div
                          className={`drop_box_ticket ${ticketPopUpIndex === ticektindex ? "active" : ""
                            }`}
                        >
                          {ticketPopUpIndex === ticektindex &&
                            (window.innerWidth < 768 ? (
                              <CustomModal
                                closeFunc={closePopUp}
                                closeFuncState={setTicketPopUpIndex}
                                children={
                                  <DropBoxPop
                                    title={"Information"}
                                    jsonInfo={
                                      getTicketCategorieInfo(event[0])
                                        ?.description
                                    }
                                    icon={<InfoIcon />}
                                    delivery={convertTicketDeliveryDate(
                                      getTicketCategorieInfo(event[0])
                                        ?.ticket_delivery_days
                                    )}
                                    Seating={
                                      getTicketCategorieInfo(event[0])
                                        ?.party_size_together
                                    }
                                    ticket_type={
                                      event[1][0]?.type_ticket === "eticket"
                                        ? "E-ticket"
                                        : " Pick-up ticket"
                                    }
                                  />
                                }
                              />
                            ) : (
                              <>
                                {
                                  <DropBoxPop
                                    title={"Information"}
                                    jsonInfo={
                                      getTicketCategorieInfo(event[0])
                                        ?.description
                                    }
                                    delivery={convertTicketDeliveryDate(
                                      getTicketCategorieInfo(event[0])
                                        ?.ticket_delivery_days
                                    )}
                                    Seating={
                                      getTicketCategorieInfo(event[0])
                                        ?.party_size_together
                                    }
                                    ticket_type={
                                      event[1][0]?.type_ticket === "eticket"
                                        ? "E-ticket"
                                        : " Pick-up ticket"
                                    }
                                    icon={<InfoIcon />}
                                  />
                                }
                              </>
                            ))}
                        </div>
                      </span>
                    )}
                  </div>
                </div>
                {Object.entries(daysGrouped(event[1]))?.map(
                  (item, cartIndex) => {
                    return (
                      <TicketContent item={item} onHoverCatIdFromEvent={onHoverCatIdFromEvent}
                        getHoverOnBasedOfTicket={getHoverOnBasedOfTicket}
                        ticketData={ticketData}
                        onHoverCatIDFromSvg={onHoverCatIDFromSvg}
                        reservationData={reservationData}
                        ticektindex={ticektindex}
                        cartIndex={cartIndex}
                        setOnHoverCatIdFromEvent={setOnHoverCatIdFromEvent}
                        priceTicketCategoryIndex={priceTicketCategoryIndex}
                        pricePopuUpIndex={pricePopuUpIndex}
                        setPricePopUpIndex={setPricePopUpIndex}
                        handlerSetWhislist={handlerSetWhislist}
                        reserveTicket={reserveTicket}
                        setPriceTicketCategoryIndex={setPriceTicketCategoryIndex}
                        event={event}
                        checkForWishListStatus={Boolean(
                          whislistItem?.find(wishList => wishList.categoryId === item?.[1]?.[0]?.category_id)
                        )}
                        showNotifyPopUp={showNotifyPopUp} setShowNotifyPopUp={setShowNotifyPopUp}

                      />

                    );
                  }
                )}
              </div>
            );
          })}
        </>
      )}
    </>
  );
};

export default EventTicketDetail;
